import { useSelector } from "react-redux";

  export const useProfileDataEditStatus = () => useSelector((state) => state.ProfileData?.edit_status);
  export const useProfileData = () => useSelector((state) => state.ProfileData);
  export const useProfileUsername = () => useSelector((state) => state.ProfileData?.profile_information_data?.username);
 